import { defaultStoreUtils } from '@databases/redux';
import { selectHasSelectedCells } from '@databases/redux/cellSelections/selectors';
import { useCallback } from 'react';

import { doExportContent } from './export';
import { useCopyListener } from './hooks/copy';

const CopyListener = ({ contentId }: { contentId: string }) => {
  const store = defaultStoreUtils.useStore();

  const hasSelection = defaultStoreUtils.useEqualSelector((state) => {
    return selectHasSelectedCells(state, {
      contentId,
    });
  });

  const handleExportDatabaseContent = useCallback(async () => {
    await doExportContent(contentId, store.getState(), 'copy');
  }, [contentId, store]);

  useCopyListener({
    onCopy: handleExportDatabaseContent,
    isDisabled: !hasSelection,
  });

  return null;
};

export default CopyListener;
